import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const LazyImportSpacesPage: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ImportSpacesContainer" */ '../src/ImportSpaces/ImportSpacesPage.tsx'
			)
		).ImportSpacesPage,
});
